export const SECTIONS = {
    files: "files",
    vaults: "vaults",
    metadatamanager: "metadata-manager",
    propertysets: "property-sets",
    propertyvariables: "property-variables"
};

export const UPLOAD_PATH = "Platform/UploadedFiles/";
